var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8.5C28 12.0893 22.6267 15 16 15C9.37333 15 4 12.0893 4 8.5C4 4.91067 9.37333 2 16 2C22.6267 2 28 4.91067 28 8.5Z",
    fill: "#D6F379"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.9999C19.58 16.9999 22.92 16.2186 25.4373 14.8546C26.3638 14.3627 27.2155 13.7414 27.9667 13.0093C27.988 13.1706 28 13.3346 28 13.4999C28 17.0893 22.6267 19.9999 16 19.9999C9.37333 19.9999 4 17.0893 4 13.4999C4 13.3346 4.012 13.1706 4.03333 13.0093C4.78456 13.7414 5.63622 14.3627 6.56267 14.8546C9.07867 16.2186 12.42 16.9999 16 16.9999Z",
    fill: "#D6F379"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.9999C19.58 21.9999 22.92 21.2186 25.4373 19.8546C26.3638 19.3628 27.2155 18.7414 27.9667 18.0093C27.988 18.1706 28 18.3346 28 18.4999C28 22.0893 22.6267 24.9999 16 24.9999C9.37333 24.9999 4 22.0893 4 18.4999C4 18.3346 4.012 18.1706 4.03333 18.0093C4.78454 18.7414 5.63621 19.3627 6.56267 19.8546C9.07867 21.2186 12.42 21.9999 16 21.9999Z",
    fill: "#D6F379"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.9999C19.58 26.9999 22.92 26.2186 25.4373 24.8546C26.3638 24.3628 27.2155 23.7414 27.9667 23.0093C27.988 23.1706 28 23.3346 28 23.4999C28 27.0893 22.6267 29.9999 16 29.9999C9.37333 29.9999 4 27.0893 4 23.4999C4 23.3346 4.012 23.1706 4.03333 23.0093C4.78454 23.7414 5.63621 24.3627 6.56267 24.8546C9.07867 26.2186 12.42 26.9999 16 26.9999Z",
    fill: "#D6F379"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.7a3e2f8411181a661c6e684e971dcfc1.svg";
export { ForwardRef as ReactComponent };